import React, { useContext } from "react";
import { QuestionRow } from "./QuestionRow/QuestionRow";

const RemoveVehicleConfirm = ({
  policyStateAbbr,
  vehReqContext,
  vehicleContext,
  reqVehicleClass,
}) => {
  const context = useContext(vehReqContext);
  const deleteVehicleContext = useContext(vehicleContext);
  var removedVehicle = deleteVehicleContext?.deleteVehicle;

  return (
    <>
      {/* Confirm these questions' answer */}
      <div className="row align-items-center my-3">
            <div className="col-12 col-md-6 text-primary fw-bold">
              Removed Vehicle
            </div>
      </div>
      <div className="row align-items-center my-3">
        <span className="fw-bold text-dark col-12" style={{paddingLeft:"15px"}}>
          {`${removedVehicle?.Year} ${removedVehicle?.Make} ${removedVehicle?.Model} - ${removedVehicle?.VIN}`}
        </span>
      </div>

      <QuestionRow
        reqVehicleContext={vehicleContext}
        requestType="Remove Vehicle"
        name="requestedRemovalEffDate"
        question={
          context.removeVehicleClass?.deleteStatus != true
            ? "Requested Remove Vehicle Effective Date*"
            : "Requested Policy Cancellation Effective Date*:"
        }
      />

      {context.removeVehicleClass?.deleteStatus != true ? (
        <>
          <QuestionRow
            reqVehicleContext={vehicleContext}
            requestType="Remove Vehicle"
            name="vehicleRemovalReason"
            question="What is the primary reason for removing this vehicle?*"
          />

          {removedVehicle?.vehicleRemovalExplanation != "" && (
            <QuestionRow
              reqVehicleContext={vehicleContext}
              requestType="Remove Vehicle"
              name="vehicleRemovalExplanation"
              question="Please explain..."
            />
          )}
        </>
      ) : (
        <>
            {removedVehicle?.vehicleRemovalExplanation != "" && (
              <QuestionRow
                reqVehicleContext={vehicleContext}
                requestType="Remove Vehicle"
                name="vehicleRemovalExplanation"
                question="Please explain..."
              />
            )}
            <div className="row align-items-center my-3">
              <span
                className="fw-bold text-dark fs-6 col-12" style={{paddingLeft:"15px"}}
              >
                I do not want to add a new vehicle and am requesting to cancel my
                policy.
              </span>
            </div>
        </>
      )}
    </>
  );
};

export default RemoveVehicleConfirm;
